function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import ReactDOMServer from 'react-dom/server';
import PropTypes from 'prop-types';
import { Row, Col, Button, Tooltip, Spinner } from 'reactstrap';
import L from 'leaflet';
import { Map, TileLayer, Marker } from 'react-leaflet';
import Collector from "../../../../services/collector";
import { useWorkFlow } from "../../../contexts/workflow";
import Icon from "../../../common/icon";
import Translate from "../../../common/translation";
import Api, { ROUTES } from "../../../../services/api";
import Address from "./address";
import { formatApiResponseToAddress } from "./address_utils";
import ChangeView from "./onChangeMap";
import useMap from "../map/use-map";
import 'leaflet/dist/leaflet.css';
var positionDefault = [48.8534, 2.3488];
/**
 * Complex type
 *
 * @param {*} props
 */
var AddressMap = function AddressMap(props) {
  var onChange = props.onChange,
    index = props.index;
  // hooks
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var currentOrder = collector.currentOrder,
    currentQuestion = collector.currentQuestion,
    responses = collector.responses,
    diag = collector.diag;
  var _useMap = useMap(),
    mapZoom = _useMap.mapZoom,
    center = _useMap.center,
    baseMap = _useMap.baseMap;
  // STATE
  var _useState = useState(center || positionDefault),
    _useState2 = _slicedToArray(_useState, 2),
    position = _useState2[0],
    setPosition = _useState2[1];
  var _useState3 = useState(mapZoom || 12),
    _useState4 = _slicedToArray(_useState3, 2),
    zoom = _useState4[0],
    setZoom = _useState4[1];
  var _useState5 = useState(15),
    _useState6 = _slicedToArray(_useState5, 2),
    leafletMap = _useState6[0],
    setLeafletMap = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isClickMapChoice = _useState8[0],
    setIsClickMapChoice = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    loadClick = _useState10[0],
    setLoadClick = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    tooltipOpen = _useState12[0],
    setTooltipOpen = _useState12[1];
  var _useState13 = useState(),
    _useState14 = _slicedToArray(_useState13, 2),
    valueAddress = _useState14[0],
    setValueAddress = _useState14[1];
  var mapRef = useRef();
  var icon = L.divIcon({
    className: 'custom-icon',
    html: ReactDOMServer.renderToString( /*#__PURE__*/React.createElement(Icon, {
      name: "map-marker-alt",
      className: "collectorMapMarker"
    }))
  });
  var initializePosition = function initializePosition() {
    var community = collector.diag ? collector.diag.community : {
      polygon: null,
      polygonColor: null
    };
    var polygon = community.polygon,
      polygonColor = community.polygonColor,
      coordinate = community.coordinate;
    if (polygon && mapRef && mapRef.current) {
      var leafletElement = mapRef.current.leafletElement;
      if (typeof polygon === 'string') {
        polygon = JSON.parse(polygon);
      }
      if (coordinate) {
        setPosition(center || [coordinate[1], coordinate[0]]);
      }
      var polygonLeaflet = L.polygon(polygon, {
        color: polygonColor || '#0d9fdb'
      }).addTo(leafletElement);
      leafletElement.fitBounds(polygonLeaflet.getBounds());
    } else {
      setPosition(center || (coordinate ? [coordinate[1], coordinate[0]] : positionDefault));
    }
  };

  /**
   * @param {number} lat
   * @param {number} lng
   * @param {number} zoom
   */
  var updatePosition = function updatePosition(lat, lng, zoom) {
    if (zoom) {
      setZoom(zoom);
    }
    setPosition([lat, lng]);
    if (leafletMap && leafletMap.flyTo) {
      leafletMap.flyTo([lat, lng]);
    }
  };

  /**
   * @param {Event} e
   */
  var handleMapClick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var _diag$community, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isClickMapChoice) {
              _context.next = 14;
              break;
            }
            setLoadClick(true);
            setIsClickMapChoice(!isClickMapChoice);
            updatePosition(e.latlng.lat, e.latlng.lng, 17);
            _context.next = 6;
            return Api.post(ROUTES.REVERSE_GEOCODE, {
              location: e.latlng,
              communityId: (_diag$community = diag.community) === null || _diag$community === void 0 ? void 0 : _diag$community.id
            });
          case 6:
            response = _context.sent;
            if (response.data[0]) {
              _context.next = 10;
              break;
            }
            setLoadClick(false);
            return _context.abrupt("return");
          case 10:
            setValueAddress(null);
            setValueAddress(response.data[0]);
            onChange(responses, response.data[0], null, index);
            setLoadClick(false);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleMapClick(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  /**
   * When the component <Address /> auto-update.
   *
   * @param {object} value -> address, coordinate and others values.
   */
  var handleAddressUpdate = function handleAddressUpdate(value) {
    var coordinate = value.coordinate;
    coordinate && updatePosition(coordinate[1], coordinate[0], 17);
  };
  var initialization = useCallback(function () {
    // Get the values inside the context
    var responsesFromHistoric = Collector.getCurrentOrderResponses(currentOrder, responses);
    var addressResponse = responsesFromHistoric ? responsesFromHistoric.responses : null;

    // Get the coordinate.
    if (addressResponse) {
      addressResponse = formatApiResponseToAddress(addressResponse, currentQuestion.alias);
      setValueAddress(addressResponse);
      if (addressResponse.coordinate && Array.isArray(addressResponse.coordinate)) {
        updatePosition(addressResponse.coordinate[1], addressResponse.coordinate[0], 17);
      }
    } else if ('geolocalisation' in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        updatePosition(position.coords.latitude, position.coords.longitude, 17);
      });
    } else {
      initializePosition();
    }
  }, [currentOrder, responses]);
  var handleChangeAddress = function handleChangeAddress(responses, values, n, idx) {
    onChange(responses, values, n, idx);
    if (!values || !values.address) {
      setIsClickMapChoice(!isClickMapChoice);
      initializePosition();
      setIsClickMapChoice(false);
      setZoom(12);
    }
  };
  useEffect(function () {
    if (!collector || !collector.diag || !collector.diag.community || !mapRef) {
      return;
    }
    initialization();
  }, []);
  useEffect(function () {
    return function () {
      initializePosition();
      setZoom(12);
      setIsClickMapChoice(false);
      setTooltipOpen(false);
      setValueAddress(false);
    };
  }, []);
  return /*#__PURE__*/React.createElement(Row, {
    className: "flex-column-reverse flex-sm-row pb-2",
    style: {
      minHeight: 250
    }
  }, /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 12,
      offset: 12
    },
    md: {
      size: 6
    }
  }, /*#__PURE__*/React.createElement(Address, {
    onUpdate: handleAddressUpdate,
    onChange: handleChangeAddress,
    value: valueAddress
  })), /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 12,
      offset: -12
    },
    md: {
      size: 6
    }
  }, /*#__PURE__*/React.createElement(Map, {
    className: "collectorMapContainer ".concat(isClickMapChoice ? 'choiceActive' : null),
    onClick: handleMapClick,
    center: position,
    whenCreated: setLeafletMap,
    zoom: zoom,
    ref: mapRef,
    attributionControl: false
  }, /*#__PURE__*/React.createElement(TileLayer, {
    attribution: "wever",
    url: baseMap
  }), function (map) {
    return /*#__PURE__*/React.createElement(ChangeView, {
      map: map,
      center: position,
      zoom: zoom
    });
  }, position && /*#__PURE__*/React.createElement(Marker, {
    position: position,
    icon: icon
  }), /*#__PURE__*/React.createElement("div", {
    className: "collectorMapSelect"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    color: "default",
    onClick: function onClick() {
      return setIsClickMapChoice(!isClickMapChoice);
    },
    id: "collectorMapSelectButton",
    active: isClickMapChoice,
    disabled: loadClick,
    style: {
      border: '1px solid black',
      color: 'black'
    }
  }, !loadClick ? /*#__PURE__*/React.createElement(Icon, {
    name: "map-pin"
  }) : /*#__PURE__*/React.createElement(Spinner, {
    size: "sm"
  })), /*#__PURE__*/React.createElement(Tooltip, {
    placement: "right",
    isOpen: tooltipOpen,
    target: "collectorMapSelectButton",
    toggle: function toggle() {
      return setTooltipOpen(!tooltipOpen);
    },
    style: {
      color: 'black'
    }
  }, /*#__PURE__*/React.createElement(Translate, {
    id: "collector_map_tooltip_button"
  })))), /*#__PURE__*/React.createElement("span", {
    className: "hidden invisible"
  }, "48.7258501, 2.2613989")));
};
AddressMap.propTypes = {
  onChange: PropTypes.func.isRequired,
  elements: PropTypes.arrayOf(PropTypes.shape({}))
};
AddressMap.defaultProps = {
  elements: []
};
export default AddressMap;